import type {
  RuntimeCapabilities,
  RuntimeCapabilityProvider,
} from '../../application/ports/RuntimeCapabilityProvider';

export class BrowserRuntimeCapabilityProvider implements RuntimeCapabilityProvider {
  public getCapabilities(): RuntimeCapabilities {
    return {
      secureContext: globalThis.isSecureContext === true,
      randomUUIDAvailable: typeof globalThis.crypto?.randomUUID === 'function',
      getRandomValuesAvailable: typeof globalThis.crypto?.getRandomValues === 'function',
      indexedDbAvailable: typeof globalThis.indexedDB !== 'undefined',
      serviceWorkerAvailable:
        typeof globalThis.navigator !== 'undefined' && 'serviceWorker' in globalThis.navigator,
    };
  }
}
